/* @jsxImportSource react */

export type CustomerRatingsCountProps = {
  /* 
    @param reviewCount - the review count
  */
  ratingsCount: number;
  /* 
    @param {boolean} [isLinked=false] - indicates if the component is linked and should therefore visible as link
  */
  isLinked?: boolean;
};

/**
 * Displays the Customer Ratings reviews count
 * */
export const CustomerRatingsCount = ({
  ratingsCount,
  isLinked = false,
}: CustomerRatingsCountProps) => (
  <span
    className={`text-color-text-dark text-size-body-sm leading-2 ${isLinked ? 'after:bg-color-text-dark relative cursor-pointer after:absolute after:inset-x-0 after:bottom-0 after:block after:h-px after:content-[""]' : ''}`}
  >
    ({ratingsCount})
  </span>
);
